<template>
    <div>
      <ul >
        <li class="skeleton_warp" v-for="(item, index) in data" :key="index">
          <div class="first_li">
            <div class="av animation_box"></div>
            <p class="animation_box"></p>
          </div>
          <p class="item animation_box"></p>
          <p class="item animation_box"></p>
          <p class="item animation_box"></p>
          <p class="item animation_box"></p>
        </li>
        
      </ul>
    </div>
      
  </template>
  <script>
  export default {
    name: 'HelloWorld',
    props: {
      data: Number
    }
  }
  </script>
  <style lang="scss" scoped>
  @import "~@/assets/sass/global.scss";
  .skeleton_warp {
    width: 100%;
    height: rem2(200px);
    background: #ffffff;
    padding:rem2(15px); 
    box-sizing: border-box;
    border-bottom: rem2(1px) solid #e8e8e8;
    .item{
      height: rem2(7px);
      background: #fffcfc;
      margin-top: rem2(15px);
     
    }
    .av{
      width: rem2(40px);
      height: rem2(40px);
      background: #fffcfc;
      display: inline-block;
      border-radius: 50%;
    }
    .first_li{
      height: rem2(50px);
      display: flex;
      background: #ffffff;
      align-items: center;
      
      >p{
        width: rem2(70px);
        height: rem2(5px);
        background: #fffcfc;
        margin-left:rem2(15px);
        margin-bottom:rem2(3px);
      }
      
    }
    .animation_box{
        animation: myfirst 1s infinite;
      }
  
    @keyframes myfirst {
        0% {background:#e8e8e8;}
        50% {background: #f0f0f0;}
        100% {background:#e8e8e8;}
    }
  }
  </style>